import React from "react";
import { AlertTriangle, CheckCircle2, Circle, BellRing } from "lucide-react";

// Shown for company-listed collectors: they only receive leads once these items are done.
export const ProfileCompletionCard = ({ completion, who = "this collector", onFix, nudges, onNudge }) => {
  if (!completion || completion.complete) return null;
  const pct = Math.round((completion.done / completion.total) * 100);
  return (
    <div className="mb-6 rounded-2xl border border-[#E9C46A] bg-[#E9C46A]/10 p-5" role="status" aria-live="polite" data-testid="profile-completion-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-[#8A5A00] mt-0.5 shrink-0"/>
          <div>
            <h2 className="font-heading text-lg text-[#1E3F33]">Profile incomplete — {who === "you" ? "you won't" : `${who} won't`} receive leads yet</h2>
            <p className="text-sm text-[#5C6B64] mt-1">Leads start as soon as the profile is complete. {who === "you" ? "You or your company" : "You or the collector"} can finish it.</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {onNudge && <button type="button" onClick={onNudge} data-testid="profile-completion-nudge" className="btn-secondary text-sm inline-flex items-center gap-1.5"><BellRing className="w-4 h-4"/> Send reminder now</button>}
          {onFix && <button type="button" onClick={onFix} data-testid="profile-completion-fix" className="btn-primary text-sm">Complete profile</button>}
        </div>
      </div>
      <div className="mt-4 flex items-center gap-3">
        <div className="h-2 flex-1 rounded-full bg-[#1E3F33]/10 overflow-hidden"><div className="h-full bg-[#2D6A4F]" style={{ width: `${pct}%` }} /></div>
        <span className="text-xs text-[#5C6B64] tabular-nums" data-testid="profile-completion-progress">{completion.done}/{completion.total}</span>
      </div>
      <ul className="mt-3 grid sm:grid-cols-2 gap-1.5" data-testid="profile-completion-missing">
        {completion.missing.map((m) => <li key={m} className="text-xs text-[#1E3F33] inline-flex items-center gap-1.5"><Circle className="w-3 h-3 text-[#8A5A00]"/> {m}</li>)}
        {completion.done > 0 && <li className="text-xs text-[#2D6A4F] inline-flex items-center gap-1.5"><CheckCircle2 className="w-3 h-3"/> {completion.done} item{completion.done === 1 ? "" : "s"} done</li>}
      </ul>
      {nudges && (
        <p className="text-[11px] text-[#8A9A86] mt-3" data-testid="profile-completion-nudge-info">
          {who === "you" ? "We'll text and email you" : "We text and email them"} reminders on day 1, 3, 7, then weekly (up to 6) until complete
          {nudges.last_at ? ` · last reminder ${new Date(nudges.last_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}` : ""} · {nudges.count || 0}/6 sent.
        </p>
      )}
    </div>
  );
};
